import type { ReactNode } from 'react';

interface PageWrapperProps {
  title: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  children?: ReactNode;
}

const PageWrapper = ({ title, description, actions, children }: PageWrapperProps) => (
  <div className="min-h-full w-full bg-background">
    <article className="mx-auto flex max-w-screen-2xl flex-col gap-8 px-6 py-8 sm:px-8 lg:px-12 lg:py-10">
      <header className="flex items-center justify-between gap-4">
        <div className="flex min-w-0 flex-col gap-1.5">
          <h1 className="text-3xl font-semibold leading-tight tracking-tight text-gray-900">{title}</h1>
          {description && <div className="text-sm text-muted-foreground">{description}</div>}
        </div>
        {actions && <div className="flex flex-shrink-0 items-center gap-2">{actions}</div>}
      </header>
      <div className="flex flex-col gap-6">{children}</div>
    </article>
  </div>
);

export default PageWrapper;
